export enum ErrorCode {
  MissingCountryCode = 422,
  Forbidden = 403,
}
